import { Injectable } from '@angular/core';
import { DynamicScriptLoaderService } from './dynamicScriptLoaderService';
import { WorkSheet, WorkBook } from 'xlsx/types';
import { CommonService } from './app.common.service';
import { DatePipe } from '@angular/common';

declare const XLSX: any;
declare const FileSaver: any;
declare const saveAs: any;

@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {
  constructor(public dynamicScripts: DynamicScriptLoaderService, private common: CommonService, public datepipe: DatePipe,) { }


  public exportToExcel(records: any, listingFields: any, systemPage: any): void {
    let listData = records;
    let pageFields = listingFields;
    let fileName = this.common.normalizedFileName(this.common.getDocumentTitle()) + "_" + this.common.formatDate(Date.now(), "dddd, MMMM Do YYYY, HH:mm:ss");
    if (systemPage && !this.common.isNullOrWhiteSpace(systemPage.pageTitle))
      fileName = this.common.normalizedFileName(systemPage.pageTitle) + "_" + this.common.formatDate(Date.now(), "dddd, MMMM Do YYYY, HH:mm:ss");
    fileName += ".xlsx";
    let properties = Object.getOwnPropertyNames(records[0]);
    for (var f in pageFields) {
      var pageField = pageFields[f];
      let propertyName = pageField.columnName;
      //this is done to avoid javascript case sensitivity issue
      if (propertyName != null && properties != null) {
        propertyName = properties.filter(function (prop) {
          return prop != null && prop.toLowerCase() == propertyName.toLowerCase()
        })[0];
        pageField["normalizedColumnName"] = propertyName;
      }
    }


    let exportRecords: any[] = [];
    var sn = 1;
    for (var d in listData) {
      let data = listData[d];

      let exportData: any = { "#": sn };
      for (var f in pageFields) {
        let pageField = pageFields[f];

        let normalizedColumnName = pageField.normalizedColumnName;
        let columnName = pageField.columnName;
        let value = data[normalizedColumnName];

          if (pageField.columnType != null && pageField.columnType.toLowerCase() == 'date') {
            if (!this.common.isNullOrWhiteSpace(value))
              value = this.common.formatDate(value);

          }
          else if (pageField.columnType != null && pageField.columnType.toLowerCase() == 'datetime') {
            try {
              if (!this.common.isNullOrWhiteSpace(value))
                value = this.common.formatDate(value,"", true);
            } catch (e) { }
          } else if (pageField.columnType != null && pageField.columnType.toLowerCase() == 'time') {
            try {
              value = this.datepipe.transform(value, 'HH:mm');
            } catch (e) { }
          }

        exportData[pageField.columnHeader] = value;
      }
      exportRecords.push(exportData);
      sn++;
    }
    this.exportAsExcelFile(exportRecords, fileName)
  }



  public exportAsExcelFile(json: any[], excelFileName: string): void {
    this.common.Loader.show();
    this.dynamicScripts.load('xlsx').then(data => {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(json, { raw: false });
      XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
      XLSX.writeFile(workBook, excelFileName); // initiate a file download in browser
      this.common.Loader.hide();
    });
  }


}
